module.exports = window.LOAD_REMOTE_ENTRY("Shared", "admin", "sharedEntry.js");